import { Button, Grid } from "@mui/material";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdsClick, Campaign } from "@mui/icons-material";

import CampaignStatus from "../Status";
import AdminCampaignStatus from "../AdminCampaignStatus";
import CampaignButtons from "../CreateCampaignButtons";
import { PageHeader } from "../../../../components";
import Connections from "../../superadmin campaign details component/ConnectionList";
import EditButtons from "../../../../components/EditButtons";
import {
  CancelButton,
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../../css components/Button";
import { alert } from "../../../../redux/slices/alertSlice";
import pages from "../../../../constants/pages";
import { colors } from "../../../css components/Style";
import { useDynamicSignatureAxios } from "../../../../hooks/useDynamicSignatureAxios";

const buttonStyles = (isActive) => ({
  fontSize: "16px",
  fontWeight: "500",
  color: colors.purple,
  backgroundColor: isActive ? colors.lightPurple : undefined,
  padding: "8.5px 20px",
  borderRadius: "16px",
  "&:hover": {
    backgroundColor: isActive ? colors.lightPurple : "#e988df36",
    padding: "8.5px 20px",
  },
  marginRight: "15px",
});

export default function HeadersAndButtons({
  editState,
  liveUsers,
  formikProps,
  setEditState,
  component = "",
  setTakeUpOffer,
  preferredChannels,
  connectionList,
  isSubmitted,
  forceClick,
  setForceClick,
  brandIdentity,
  audienceSize,
  setIsSubmitted,
  activeBrand,
  channelSectionRef,
  tabValue,
  setTabValue,
}) {
  const axios = useDynamicSignatureAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState();

  const scrollToChannelSection = () => {
    channelSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <Fragment>
      <Grid size={12}>
        <PageHeader
          pageName={"Campaigns"}
          pageHeader={
            formikProps.values.campaign_name.value
              ? formikProps.values.campaign_name.value
              : "Let's create campaign"
          }
          buttons={[
            tabValue === "Campaign" && (
              <CampaignButtons
                isDisabled={isSubmitted}
                ID={formikProps.values.campaignID}
                editState={editState}
                liveUsers={liveUsers}
                setEditState={setEditState}
                formikProps={formikProps}
                component={component}
                brandIdentity={brandIdentity}
                setTakeUpOffer={setTakeUpOffer}
                setIsSubmitted={setIsSubmitted}
              />
            ),

            !!formikProps.values.campaignID &&
              !isSubmitted &&
              formikProps.values.newCampaignStatus !== "CREATED" &&
              formikProps.values.campaignStatus !== "Expired" &&
              !formikProps.values?.IsManualCampaignLive &&
              (forceClick ? (
                <Fragment>
                  <PrimaryButton
                    variant="contained"
                    onClick={() => {
                      setForceClick(false);
                      scrollToChannelSection();
                    }}
                  >
                    Edit Channel Details
                  </PrimaryButton>

                  <CancelButton
                    style={{ marginLeft: "5px" }}
                    onClick={() => {
                      if (!forceClick) {
                        navigate(-1);
                      } else {
                        navigate(pages.myCampaign.route);
                      }
                    }}
                    variant="outlined"
                  >
                    Back
                  </CancelButton>
                </Fragment>
              ) : (
                <Fragment>
                  <PrimaryLoadingButton
                    variant="contained"
                    onClick={handleChannelDetails}
                    loading={loading}
                    color="primary"
                    sx={{ marginRight: "4px" }}
                  >
                    Submit
                  </PrimaryLoadingButton>
                  <CancelButton
                    variant="outlined"
                    onClick={() => setForceClick(true)}
                  >
                    Cancel
                  </CancelButton>
                </Fragment>
              )),

            isSubmitted &&
              (formikProps.values.adminApprovalStatus === "REQUESTED" ||
                formikProps.values.adminApprovalStatus === "ACCEPTED") && (
                <CancelButton
                  onClick={() => {
                    navigate(pages.myCampaign.route);
                  }}
                  variant="outlined"
                >
                  Back
                </CancelButton>
              ),

            tabValue === "Campaign" &&
              formikProps.values.status === "CREATED" &&
              formikProps.values.adminApprovalStatus === "NOT_SENT" && (
                <EditButtons
                  ID={formikProps.values.campaignID}
                  formikProps={formikProps}
                  editState={editState}
                  setEditState={setEditState}
                />
              ),
          ]}
        />

        <Grid size={12} sx={{ marginTop: "10px" }}>
          <Button
            sx={buttonStyles(tabValue === "Campaign")}
            onClick={() => setTabValue("Campaign")}
          >
            <Campaign sx={{ fontSize: "30px", marginRight: "5px" }} />
            Campaign
          </Button>

          {formikProps.values.campaignID && (
            <Button
              sx={buttonStyles(tabValue !== "Campaign")}
              onClick={() => setTabValue("Creative")}
            >
              <AdsClick sx={{ fontSize: "25px", marginRight: "5px" }} />
              {"   "}Creative
            </Button>
          )}
        </Grid>

        {component !== "" &&
          formikProps.values.campaignStatus !== "REQUESTED" && (
            <Grid size={12}>
              <CampaignStatus
                formikProps={formikProps}
                setTakeUpOffer={setTakeUpOffer}
              />
            </Grid>
          )}

        {component === "" && (
          <Grid size={12}>
            <AdminCampaignStatus
              component={component}
              isDisabled={isSubmitted}
              preferredChannels={preferredChannels}
              audienceSize={audienceSize}
              formikProps={formikProps}
              setForceClick={setForceClick}
              channelSectionRef={channelSectionRef}
              scrollToChannelSection={scrollToChannelSection}
            />
          </Grid>
        )}

        {component === "" &&
          formikProps.values.permissionSettings?.connection_list && (
            <Connections
              connections={connectionList}
              formikProps={formikProps}
            />
          )}
      </Grid>
    </Fragment>
  );

  function checkChannelFields(values) {
    const prefChannels = values?.pref_campaign_channel?.value || [];

    if (prefChannels.length === 0) {
      return false;
    }

    let requiredFields = formikProps.values.channelFields || [];
    requiredFields = [...new Set(requiredFields)];

    return requiredFields.every((field) => !!values?.[field]?.value);
  }
  function handleChannelDetails() {
    setLoading(true);
    if (!checkChannelFields(formikProps.values)) {
      dispatch(
        alert({
          type: "error",
          message: "Please fill the necessary details for channels.",
        })
      );
      setLoading(false);

      return;
    }
    let fields = [];

    const requiredFields = [
      "dv_partner_id",
      "dv_advertiser_id",
      "dv_advertiser_name",
      "ad_manager_id",
      "pref_campaign_channel",
    ];

    requiredFields
      .filter((f) => formikProps.values[f].value)
      .map((val) => fields.push({ [val]: formikProps.values[val] }));

    let data = {
      brand_id: parseInt(activeBrand.ID),
      audience_id: formikProps.values.audienceID,
      update_data: true,
      fields: fields,
    };

    axios({
      url: "/user/update/campaign/" + formikProps.values.campaignID,
      method: "PUT",
      data: data,
      disableRedirect: true,
    }).then((response) => {
      console.log(response);
      if (response.status) {
        setForceClick(true);

        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
        setIsSubmitted(checkChannelFields(formikProps.values));
      }
    });
    setLoading(false);
  }
}
